/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 申込情報
 */
export interface Sgkb575aResSrnInfo {
    /** 
     * 申込方法：半角英数混在
     */
    srnMethod?: string;
    /** 
     * 申込方法名称：全角半角混在
     */
    mousikomihohoAname?: string;
    /** 
     * 廃止後支払方法変更区分コード：半角英数混在
     */
    haishigoPaymentmethodchangeDivcd?: string;
    /** 
     * 廃止後支払方法変更区分コード名称：全角半角混在
     */
    haishigopaymentmethodChgdivCodeaname?: string;
    /** 
     * 廃止後支払送信先電話番号：電話番号(ハイフンと数値含む)
     */
    haishigoPaytotelno?: string;
    /** 
     * 廃止後支払送付先選択コード：半角英数混在
     */
    haishigoPaymentdestinationselectcode?: string;
    /** 
     * 廃止後支払送付先選択コード名称：全角半角混在
     */
    haishigoPaymentdestinationselectcodeAname?: string;
    /** 
     * 廃止後支払送付先住所コード：半角英数混在
     */
    haishigoPaymentdestinationAddrcd?: string;
    /** 
     * 廃止後支払送付先郵便番号：半角数字
     */
    haishigoPaymentdestinationpostno?: string;
    /** 
     * 廃止後支払送付先都道府県名称：全角文字
     */
    haishigopaymentdestinationPfcAname?: string;
    /** 
     * 廃止後支払送付先市区郡町村名称：全角文字
     */
    haishigopaymentdestinationMptAname?: string;
    /** 
     * 廃止後支払送付先町域名称：全角文字
     */
    haishigopaymentdestinationTwareaAname?: string;
    /** 
     * 廃止後支払送付先大字丁目名称：全角文字
     */
    haishigopaymentdestinationOazaAname?: string;
    /** 
     * 廃止後支払送付先番地・号・分筆号：全角文字
     */
    haishigoPaymentdestinationBlockgoulot?: string;
    /** 
     * 廃止後支払送付先住宅・棟号漢字名：全角文字
     */
    haishigoPaymentdestinationAddressaname?: string;
    /** 
     * 廃止後支払送付先表示住所漢字：全角文字
     */
    haishigopaymentdestinationSazvjjsKanji?: string;
    /** 
     * 廃止後支払送付先屋号・業種漢字名：全角文字
     */
    haishigoPaymentdestinationYagou?: string;
    /** 
     * 廃止後支払送付先宛名：全角文字
     */
    haishigoPaymentdestinationAddressee?: string;
    /** 
     * 廃止後支払送付先宛名カナ：全角カナ
     */
    haishigoPaymentdestinationAddresseekana?: string;
    /** 
     * 廃止後支払送付先手入力フラグ：半角数字
     */
    haishigoPaymentdestinationinputflag?: string;
    /** 
     * 廃止後支払送付先手入力フラグ名称：全角半角混在
     */
    haishigopaymentdestinationInputFlganame?: string;
    /** 
     * 廃止後支払送付先都道府県：全角文字
     */
    haishigoPaymentdestinationprefecture?: string;
    /** 
     * 廃止後支払送付先行政市区：全角文字
     */
    haishigoPaymentdestinationadminstcity?: string;
    /** 
     * 廃止後支払送付先行政町名：全角文字
     */
    haishigoPaymentdestinationadminstchoname?: string;
    /** 
     * 廃止後支払送付先丁目：全角文字
     */
    haishigoPaymentdestinationchome?: string;
    /** 
     * 移転先住所コード：半角英数混在
     */
    transferdestinationAddrcd?: string;
    /** 
     * 移転先住所郵便番号：半角数字
     */
    transferdestinationAddrPostno?: string;
    /** 
     * 移転先住所都道府県名称：全角文字
     */
    transferdestinationaddressPfcAname?: string;
    /** 
     * 移転先住所市区郡町村名称：全角文字
     */
    transferdestinationaddressMptAname?: string;
    /** 
     * 移転先住所先町域名称：全角文字
     */
    transferdestinationaddressTwareaAname?: string;
    /** 
     * 移転先住所大字丁目名称：全角文字
     */
    transferdestinationaddressOazaAname?: string;
    /** 
     * 移転先住所番地・号・分筆号：全角文字
     */
    transferdestinationAddrBlockgoulot?: string;
    /** 
     * 移転先住所番地・号・分筆号（カナ）：全角英数カナ
     */
    transferdestinationAddrBlockgoulotkana?: string;
    /** 
     * 移転先住所住宅・棟号漢字名：全角文字
     */
    transferdestinationAddrAddressaname?: string;
    /** 
     * 移転先住所住宅・棟号カナ名：全角文字
     */
    transferdestinationaddressSupadrKana?: string;
    /** 
     * 移転先住所屋号・業種漢字名：全角文字
     */
    transferdestinationAddrYagou?: string;
    /** 
     * 移転先住所屋号・業種カナ名：全角文字
     */
    transferdestinationaddressYagouKana?: string;
    /** 
     * SW用お客さま名義カナ：全角カナ
     */
    forswitchVisitornameKana?: string;
    /** 
     * SW用お客さま名義漢字：全角文字
     */
    forswitchVisitornameKanji?: string;
    /** 
     * 請求書継続発行フラグ：半角英数混在
     */
    billContinuationissuanceFlg?: string;
    /** 
     * 請求書継続発行フラグ名称：全角半角混在
     */
    billContinuationissuanceFlganame?: string;
    /** 
     * キャンペーンコード：半角英数混在
     */
    campaignCode?: string;
    /** 
     * キャンペーン名称：全角文字
     */
    campaignAname?: string;
    /** 
     * 本登録完了通知抽出ステータス：半角英数混在
     */
    honregistrationKanryonoticeExtractionstatus?: string;
    /** 
     * 本登録完了通知抽出ステータス名称：全角半角混在
     */
    honregistrationKanryonoticeExtractionstatusAname?: string;
    /** 
     * マッチング完了通知抽出ステータス：半角英数混在
     */
    matchingKanryonoticeExtractionstatus?: string;
    /** 
     * マッチング完了通知抽出ステータス名称：全角半角混在
     */
    matchingKanryonoticeExtractionstatusAname?: string;
    /** 
     * 契約手続き完了通知抽出ステータス：半角英数混在
     */
    contractprocedureKanryonoticeExtractionstatus?: string;
    /** 
     * 契約手続き完了通知抽出ステータス名称：全角半角混在
     */
    contractprocedureKanryonoticeExtractionstatusAname?: string;
    /** 
     * 手続き完了おしらせ直送可否フラグ：半角英数混在
     */
    procedurecompletionNoticeDeliverypossibility?: string;
    /** 
     * 手続き完了おしらせ直送可否フラグ名称：全角半角混在
     */
    procedurecompletionnoticeDeliverypossibilityFlganame?: string;
    /** 
     * 通知方法コード：半角英数混在
     */
    tutiMthdiv?: string;
    /** 
     * 通知方法コード名称：全角半角混在
     */
    tutiMthdivAname?: string;
    /** 
     * 契約手続き完了通知紙希望フラグ：半角英数混在
     */
    ctrProcedurecompletionPaperhopeflag?: string;
    /** 
     * 契約手続き完了通知紙希望フラグ名称：全角半角混在
     */
    contractprocedurecompletenotificationPaperhopeFlganame?: string;
    /** 
     * 開栓結果登録済フラグ：半角英数混在
     */
    opentapresultRegistrationflag?: string;
    /** 
     * 開栓結果登録済フラグ名称：全角半角混在
     */
    opentapresultRegistrationflagAname?: string;
}
